import React from "react";
import { motion } from "framer-motion";
import { APPROACH, STATS, TEAM } from "@/data/content";

export const Experience = () => {
  return (
    <section id="experiencia" className="py-20 md:py-28 bg-[#f2ebe1]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#ff5c49]">
            {APPROACH.overline}
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight mt-4 leading-tight">
            Claridad, organización y resultados
          </h2>
          <p className="mt-5 text-lg text-[#6b6873] leading-relaxed">{APPROACH.intro}</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {APPROACH.steps.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`approach-step-${i}`}
              className="bg-white border border-[#e4dccf] rounded-2xl p-7 hover:-translate-y-1.5 hover:shadow-lg transition-all duration-300"
            >
              <span className="font-display text-4xl font-extrabold text-[#ff5c49]/30">
                {step.n}
              </span>
              <h3 className="font-display text-xl font-bold uppercase tracking-wide mt-3">
                {step.name}
              </h3>
              <p className="mt-3 font-semibold text-[#2b2a33] leading-snug">{step.tagline}</p>
              <p className="mt-3 text-sm text-[#6b6873] leading-relaxed">{step.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {STATS.map((s, i) => (
            <div key={i} data-testid={`stat-${i}`} className="border-l-2 border-[#ff5c49] pl-4">
              <p className="font-display text-3xl md:text-4xl font-extrabold leading-none">
                {s.value}
              </p>
              <p className="mt-2 text-sm text-[#6b6873]">{s.label}</p>
            </div>
          ))}
        </div>

        {/* Team */}
        <div className="mt-16">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#12b2a0]">
            Quiénes somos
          </span>
          <div className="mt-6 grid sm:grid-cols-2 gap-5">
            {TEAM.map((m, i) => (
              <div
                key={i}
                data-testid={`team-${i}`}
                className="bg-white border border-[#e4dccf] rounded-2xl p-6"
              >
                <p className="font-display text-lg font-bold">{m.name}</p>
                <p className="text-xs font-semibold uppercase tracking-wide text-[#ff5c49] mt-1">
                  {m.role}
                </p>
                <p className="mt-3 text-sm text-[#6b6873] leading-relaxed">{m.bio}</p>
                {m.bio2 && (
                  <p className="mt-3 text-sm text-[#6b6873] leading-relaxed">{m.bio2}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
